import api from "../../service/api";
import { Format } from "../../tools/filter";
import ConfigureInfo from "@/connect/configureInfo";

const leverageFind = (state, rootState, type) => {
  let data = {
    baseQuantity: 0,
    leverage: 1,
  };
  if (
    !state.queryOpenOrderData.orders ||
    !state.queryOpenOrderData.orders.length
  )
    return data;
  const dataFind = state.queryOpenOrderData.orders.find((value) => {
    if (value.orderType === 2) {
      return (
        value.pair === rootState.getQueryPairInfo.pair &&
        value.direction === (type === 0 ? 1 : 0)
      );
    } else {
      return (
        value.pair === rootState.getQueryPairInfo.pair &&
        value.direction === type
      );
    }
  });
  return dataFind || data;
};

export default {
  state: () => ({
    queryOpenOrderData: {},
    tabActive: "positions",
  }),
  mutations: {
    SET_TAB_ACTIVE(state, opt) {
      state.tabActive = opt;
    },
    SET_QUERY_OPEN_ORDER_DATA(state, opt) {
      state.queryOpenOrderData = opt;
    },
    ADD_OPEN_ORDER_LIST(state, opt) {
      for (let i = 0; i < opt.length; i++) {
        state.queryOpenOrderData.orders.unshift(opt[i]);
      }

      console.log("ADD_OPEN_ORDER_LIST", state.queryOpenOrderData.orders);
    },
    UPDATE_OPEN_ORDER_LIST(state, opt) {
      opt = opt.reverse();
      state.queryOpenOrderData.orders.forEach((fatherVal, index) => {
        try {
          opt.forEach((sonVal) => {
            console.log(
              "sonVal.orderId === fatherVal.orderId",
              sonVal.orderId,
              fatherVal.orderId
            );

            if (sonVal.orderId === fatherVal.orderId) {
              Object.keys(fatherVal).forEach((fvalue) => {
                Object.keys(sonVal).forEach((svalue) => {
                  if (fvalue === svalue) {
                    state.queryOpenOrderData.orders[index][fvalue] =
                      sonVal[svalue];
                  }
                });
              });

              throw new Error("orderId");
            }
          });
        } catch (error) {
          /*eslint no-empty: "error"*/
        }
      });
      console.log("UPDATE_OPEN_ORDER_LIST", state.queryOpenOrderData.orders);
    },
    DELETE_OPEN_ORDER_LIST(state, opt) {
      console.log("DELETE_OPEN_ORDER_LIST", opt);
      console.log(
        "DELETE_OPEN_ORDER_LIST-orders",
        state.queryOpenOrderData.orders
      );
      opt.forEach((sonVal) => {
        state.queryOpenOrderData.orders.forEach((fatherVal, index) => {
          console.log(
            "sonVal.orderId === fatherVal.orderId",
            sonVal.orderId,
            fatherVal.orderId
          );
          if (sonVal.orderId === fatherVal.orderId) {
            state.queryOpenOrderData.orders.splice(index, 1);
          }
        });
      });
      console.log("DELETE_OPEN_ORDER_LIST", state.queryOpenOrderData.orders);
    },
    UP_BLOCK_HEIGHT(state, val) {
      state.queryOpenOrderData.blockHeight = val;
    },
  },
  actions: {
    async getQueryOpenOrder({ commit, rootState }, opt) {
      const queryOpenOrderData = await api["queryOpenOrder"]({
        address: opt.address,
        pair: opt.pair,
      });

      rootState.ws.websocketsend({
        type: "subscribe",
        channel: "open_orders",
        id: rootState.tradingPair.queryPairInfo.pair + "&" + opt.address,
        last_height: queryOpenOrderData.blockHeight,
        chainId: ConfigureInfo.Marginx.chainId,
      });

      commit("SET_QUERY_OPEN_ORDER_DATA", queryOpenOrderData);
      console.log("SET_QUERY_OPEN_ORDER_DATA", queryOpenOrderData);
    },
    setOpenOrders({ commit }, data) {
      // data.forEach((value) => {
      if (data) {
        if (data["addOpenOrderList"]) {
          console.log("addOpenOrderList");
          commit("ADD_OPEN_ORDER_LIST", data.addOpenOrderList);
        }

        if (data["updateOpenOrderList"]) {
          console.log("updateOpenOrderList");
          commit("UPDATE_OPEN_ORDER_LIST", data.updateOpenOrderList);
        }
        if (data["deleteOpenOrderList"]) {
          console.log("deleteOpenOrderList");
          commit("DELETE_OPEN_ORDER_LIST", data.deleteOpenOrderList);
        }
        if (data["blockHeight"]) {
          console.log("blockHeight");
          commit("UP_BLOCK_HEIGHT", data.blockHeight);
        }
      }
      // });
    },
  },
  getters: {
    getOpenOrderMaxLongLeverage: (state, rootState) => {
      return leverageFind(state, rootState, 0);
    },
    getOpenOrderMaxShortLeverage: (state, rootState) => {
      return leverageFind(state, rootState, 1);
    },
    getOpenOrderAllMargin: (state) => {
      if (!state.queryOpenOrderData.orders) return 0;

      let sum = 0;

      state.queryOpenOrderData.orders.forEach((value) => {
        if (value.orderType === 1) {
          sum = Format.init(value.lockedFee)
            .minus(value.costFee)
            .plus(value.quoteQuantity)
            .plus(sum)
            .result(false)
            .toString();
        }
      });

      return sum;
    },
  },
};
